import {Props} from './model';
import React from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import {useStyles} from '../../../../shared/hooks/styles';
import {images} from '../../../../assets/icons';
import {DeviceSize} from '../../../../shared/theme/helpers';
import {useIsDesktop} from '../../../../shared/hooks/useIsDesktop';

export default ({children, headerText, isActive, toggle, isCloseable}: Props) => {
  const isDeviceDesktop = useIsDesktop();
  const styles = useStyles(({theme, isDesktop, mediaOnly}) => ({
    card: {
      backgroundColor: theme.color.primaryNonGreyBackground,
      paddingHorizontal: isDesktop ? 30 : 20,
      paddingVertical: isDesktop ? 40 : 20,
      borderWidth: 1,
      borderColor: theme.color.borderColor,
      borderStyle: 'solid',
      borderRadius: 5,
      position: 'relative',
    },
    cardHeader: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    cardHeaderText: {
      ...mediaOnly(DeviceSize.desktop, theme.fonts.h2, theme.fonts.action),
      color: theme.color.textColor,
      textTransform: 'uppercase',
    },
    cardBody: {
      paddingTop: isDesktop ? 20 : 12,
    },
    button: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          width: 40,
          height: 40,
        },
        {
          width: 30,
          height: 30,
        },
      ),
      color: theme.color.primaryColor,
    },
    buttonIcon: {
      color: theme.color.primaryColor,
      zIndex: 2,
    },
  }));
  const ActionButtonIcon = isActive ? images.ChevronUp : images.ChevronDown;
  const HeaderContent = (
    <>
      <Text style={styles.cardHeaderText}>{headerText}</Text>
      {isCloseable && (
        <View style={styles.button}>
          <ActionButtonIcon
            width={isDeviceDesktop ? 40 : 30}
            height={isDeviceDesktop ? 40 : 30}
            color={styles.buttonIcon.color}
          />
        </View>
      )}
    </>
  );
  const Header = isCloseable ? (
    <TouchableOpacity testID='acceptor-data-card-content-id' style={styles.cardHeader} onPress={() => toggle()}>
      {HeaderContent}
    </TouchableOpacity>
  ) : (
    <View style={styles.cardHeader}>{HeaderContent}</View>
  );
  return (
    <View style={styles.card}>
      {Header}
      {isActive ? <View style={styles.cardBody}>{children}</View> : null}
    </View>
  );
};
